import { createRoute } from '@/utils/routing'

export const REFERRAL_CAMPAIGN_LIST_ROUTE = 'referral-campaigns'
export const REFERRAL_CAMPAIGN_EDIT_ROUTE = 'referral-campaigns-campaignId-edit'
export const REFERRAL_CAMPAIGN_VIEW_ROUTE = 'referral-campaigns-campaignId'
export const REFERRAL_CAMPAIGN_CREATE_ROUTE = 'referral-campaigns-create'

export function createReferralCampaignsListRoute (options = {}) {
  return createRoute(REFERRAL_CAMPAIGN_LIST_ROUTE, options)
}

export function createReferralCampaignsCreateRoute (options = {}) {
  return createRoute(REFERRAL_CAMPAIGN_CREATE_ROUTE, options)
}

export function createReferralCampaignsEditRoute (campaignId) {
  return createRoute(REFERRAL_CAMPAIGN_EDIT_ROUTE, { params: { campaignId } })
}

export function createReferralCampaignsViewRoute (campaignId) {
  return createRoute(REFERRAL_CAMPAIGN_VIEW_ROUTE, { params: { campaignId } })
}
